import { useState } from 'react';

const useItemPerPage = (initialValue: string) => {
    const [value, setValue] = useState<string>(() => {
        try {
            const itemsPerPage = localStorage.getItem('lDisplayPerPg');
            return itemsPerPage ? itemsPerPage : initialValue;
        }
        catch (err) {
            return initialValue;
        }
    })

    const itemPerPage = parseInt(value);

    const setItemPerPage = (value: string) => {
        localStorage.setItem('lDisplayPerPg', value);
        setValue(value)
    }

    return [itemPerPage, setItemPerPage]
}

export default useItemPerPage;
